import "./PageTitle.css";
import { BackButton } from "../BackButton/BackButton";

const PageTitle = ({ backRoute, ...props }) => {
	return (
		<h1 className={`page-title-container ${props.className}`}>
			<div className="flex! flex-col! items-start! gap-3 pr-6! max-w-[75%]!">
				<div className="flex flex-row justify-start items-center gap-1.5!">
					<div className="page-title-icon">
						{props.icon}
					</div>
					<span className={"page-title"}>
						{props.title}
					</span>
				</div>
				{props.text && (
					<span className="text-xs! text-(--textColor) box-border! opacity-75!">
						{props.text}
					</span>
				)}
			</div>
			{(props.noBackButton === undefined && backRoute) && (
				<BackButton route={backRoute} />
			)}
		</h1>
	);
};

export default PageTitle;
